/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-10-23 00:00:00
 *
 *******************************************************/
// @flow

import React from 'react';
import { Modal, Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';

const BFCM23PromotionPopup = props => {
  const handleCancel = () => {
    props.onClose();
  };

  const handleExplore = () => {
    mixpanelV3Helper.trackEventData('Click on BFCM popup', {
      path: window.location.pathname,
      buttonText: 'Subscribe now'
    });
    history.push(routes.subscription.plan());
  };

  const { active, i18n } = props;

  return (
    <div className="">
      <Modal
        open={active}
        size="large"
        onClose={handleCancel}
        titleHidden
        noScroll
        title={i18n.translate('AdminHTML.Dashboard.WelcomeNewFeature.merchandising_Title')}>
        <div className="PFS-BFCM23-Popup">
          <div className="closeBtn">
            <Button onClick={handleCancel} icon={MobileCancelMajor} plain />
          </div>
          {/* Explore button */}
          <div onClick={() => handleExplore()} className="action"></div>
        </div>
      </Modal>
    </div>
  );
};

export default withI18n()(BFCM23PromotionPopup);
